import { Game } from "./game.feature";

export default Game;
